import { DefaultError, useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import QUERY_KEYS from 'src/constants/queryKey'
import CAIIcon from 'src/components/CaiIcon'

type Message = {
  message: string
  type: string
  images: string[]
  time: string
  owner: string
  avatar: any
}

type Data = {
  chat_id: string
  hidden: boolean
  id: string
  sender: string
  text: string
  timestamp: string
}

export default function useGetChatMessages(sessionId?: string) {
  const { i18n } = useTranslation()

  return useQuery<{ data: Data[] }, DefaultError, Message[]>({
    queryKey: [QUERY_KEYS.CHAT_GOALS, sessionId, i18n.language],
    enabled: !!sessionId,
    queryFn: ({ signal }) =>
      fetch(
        `${process.env.REACT_APP_CARCH_ENDPOINT}/sessions/${sessionId}/messages?language=${i18n.language}`,
        {
          signal,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        },
      )
        .then((r) => r.json())
        .catch((e: unknown) => {
          throw e
        }),
    select: ({ data }) =>
      data
        .filter((i) => !i.hidden)
        .map((i) => ({
          message: i.text,
          type: i.sender === 'user' ? 'sent' : 'received',
          images: [],
          time: new Date(i.timestamp).toLocaleTimeString(),
          owner: i.sender,
          avatar: CAIIcon,
        })),
  })
}
